module.exports = __webpack_public_path__ + "static/media/Jing.2aee63d4.png";